export const LESSON_PREP_TITLE = 'Prep'

export const BB_PREP_VIDEO_TITLE = 'Brain Builder Prep Videos'
export const KEY_WORDS_TITLE = 'Key Words'
export const PREP_MATERIALS_TITLE = 'Prep Materials'
export const TEACHER_TIP_TITLE = 'Teaching Notes'
export const LESSON_PREPARATION_TITLE = 'Lesson Preparation'
export const PREP_MATERIALS_PDF_TITLE = 'Prep PDFs'
